<template lang="html">
  <pl-dialog @close="$emit('close')" :title="'Switch Moderators?'" :size="'sm'">
    <div class="flex flex-col flex-grow mx-auto p-7 justify-center">
      <div class="flex flex-row items-center">
        <div class="mr-3 text-base w-12 text-right">From:</div>
        <img
          :src="user_moderator.user.avatar_url"
          alt="avatar"
          class="mr-3 rounded-full w-8 h-8"
        />
        <div class="font-semibold text-2xl">{{ user_moderator.user.name }}</div>
      </div>
      <div class="flex flex-row items-center pt-7">
        <div class="mr-3 text-base w-12 text-right">To:</div>
        <img
          :src="participation.user.avatar_url"
          alt="avatar"
          class="mr-3 rounded-full w-8 h-8"
        />
        <div class="font-semibold text-2xl">{{ participation.user.name }}</div>
      </div>
    </div>
    <div class="flex flex-row items-center justify-center p-7">
      <button
        @click="$emit('close')"
        class="mr-2.5 px-8 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold"
      >
        NO
      </button>
      <button
        @click="switchModerator"
        class="px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold"
      >
        YES
      </button>
    </div>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        default_participation: {
          id: null,
          user: {
            name: '',
            id: null,
            rewards: [],
          },
        },
      };
    },
    props: {
      participationID: {
        type: String,
        default: '',
      },
      user_moderator: {
        type: Object,
        default: {},
      },
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion', 'hasTeacherPermissionsInCourse']),
      participation() {
        return (
          this.getCurrentDiscussion.participations.find(
            (p) => p.id === this.participationID
          ) || this.default_participation
        );
      },
    },
    methods: {
      switchModerator() {
        const user = this.getCurrentDiscussion.participations.find(
          (p) => p.id === this.participationID
        );
        this.$store
          .dispatch('moderatorChosen', {
            live_discussion_id: this.$route.params.liveDiscussionID,
            user_id: user.user_id,
          })
          .then(this.$emit('close'));
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .avatar-circle
    border: 2px solid pl-slate
  .avatar-size
    width: 30px
    height: 30px
  .from-to
    color: #595959
    font-size: 16px
  .user-name
    color: #273248
</style>



// WEBPACK FOOTER //
// moderatorModal.vue?77807e1d